export const DBASUBSCRIPTIONS_RESET_STATE = 'DBASUBSCRIPTIONS_RESET_STATE';
export const DBASUBSCRIPTIONS_CURRENT_ITEM = 'DBASUBSCRIPTIONS_CURRENT_ITEM';

export const DBASUBSCRIPTIONS_REQUEST_LOADING = 'DBASUBSCRIPTIONS_REQUEST_LOADING';
export const DBASUBSCRIPTIONS_REQUEST_SUCCESS = 'DBASUBSCRIPTIONS_REQUEST_SUCCESS';
export const DBASUBSCRIPTIONS_REQUEST_FAILED = 'DBASUBSCRIPTIONS_REQUEST_FAILED';

export const DBASUBSCRIPTIONS_CURRENT_ACTION = 'DBASUBSCRIPTIONS_CURRENT_ACTION';
export const DBASUBSCRIPTIONS_RESET_ACTION = 'DBASUBSCRIPTIONS_RESET_ACTION';
